import React, {useState} from "react";
import { Button } from "antd";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import './style.less';
import SidebarContent from "../Sidebar/SidebarContent";
import FinanceSidebarContent from "../Sidebar/FinanceSidebarContent";
import PMTSidebarContent from "../Sidebar/PMTSidebarContent";

const MobileMenu = () => {
  const history = useHistory();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const user_role = localStorage.getItem('user_role') ? localStorage.getItem('user_role') : ""
  const loged_in_to = localStorage.getItem('loged_in_to') ? localStorage.getItem('loged_in_to') : ""

  return (
    <div className="mobile--header">      
      <div className="mobile--header--logo">
        <Link to="/" className="gx-site-logo">
          <img
            className="logo"
            src={require("assets/images/uniserved_logo.png")}
            alt="3"
          />
        </Link>
      </div>
      <div className="mobile--buttons">
      <Button
        onClick={() => {
          localStorage.clear();
          history.push("/portals");
          console.log("LocalStorage cleared");
        }}
        className="gx-btn gx-btn-primary"
      >
        Logout
      </Button>
      <Button
          onClick={() => setSidebarCollapsed((prev) => !prev)}
          className="gx-btn"
        >
          <i className="icon icon-menu-fold gx-text-white"></i>
        </Button>
      </div>
      <div 
        className={`mobile--menu ${sidebarCollapsed ? "collapsed" : ""}`}
        onClick={() => setSidebarCollapsed(false)}
      >
        {loged_in_to === "pmt" ? (<PMTSidebarContent />) : loged_in_to === "fc" || loged_in_to === "ppl"? (<FinanceSidebarContent />) : loged_in_to === "orion" ? (<SidebarContent />) : ""}
      </div>
    </div>
  );
};

export default MobileMenu;
